import { render, staticRenderFns } from "./BasicBarChart.vue?vue&type=template&id=afe0e8c8"
import script from "./BasicBarChart.vue?vue&type=script&lang=js"
export * from "./BasicBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports